// @ts-strict

import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-add-general-config-first',
  templateUrl: './add-general-config-first.component.html',
  styleUrls: ['./add-general-config-first.component.scss']
})
export class AddGeneralConfigFirstComponent {
  @Input() text?: string;
  @Input() containerIcon: string = '';
  @Input() buttonText?: string;
  @Input() isAvailable?: boolean = false;
  @Input() textWithHtml: boolean = false;
  @Input() urlConfigurationDefined: boolean = false;
  @Output() emitAddConfiguration = new EventEmitter<boolean>();

  addConfiguration(): void {
    this.emitAddConfiguration.emit(true);
  }
}
